<template>
  <div style="width:100%">
    <el-table
      :data="data"
      stripe
      :dynamicOperationName="dynamicOperationName"
      @select="handleSelectionChange"
      @select-all="handleSelectAll"
      :row-key="getRowKeys"
      ref="multipleTable"
      :height="height"
      :max-height="height"
      style="width: 100%">
      <el-table-column
        type="selection"
        width="50"
        :reserve-selection="true"
        v-show="showCheck">
      </el-table-column>
      <el-table-column v-for="item in head"
                       :key="item.head"
                       :show-overflow-tooltip="show"
                       :prop="item.props"
                       :label="item.label"
                       :min-width="item.width"
                       v-if="(item.props=='studyPk') ? false : true"
      >
      </el-table-column>
      <el-table-column
        type="index"
        label=" "
        :width="operationWidth">
        <template slot-scope="scope">
          <el-button v-if="dynamicOperationName === 'imageSelect'" @click="_operation(scope.row, item.class,scope.$index)"
                     v-for="item in operation"
                     type="text"
                     :key="item.class"
                     :title="item.title"
                     :class="scope.row.readFilmFlag =='0' ? item.class : item.class2" class="iconfont" size="big"
          >{{item.operation}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script type="text/ecmascript-6">
  import {getLocalStorage, saveLocalStorage} from '@/common/js/localStorage'
  export default {
    props: {
      showCheck:{
        type: Boolean,
        default: false,
      },
      data: {
        type: Array,
        default: function () {
          return []
        }
      },
      TableData: {
        type: Array,
        default: function () {
          return []
        }
      },
      width:{
        type: String,
        default: ''
      },
      //组件内部定义了height的值。两个地方data和props。它应该用其中之一
      // height: {
      //   type: Number,
      //   default: ''
      // },
      head: {
        type: Array,
        default: []
      },
      operation: {
        type:[Object,Array] ,
        default: ()=>{}
      },
      operationWidth: {
        type: Number,
        default: 100
      },
      dynamicOperationName: {
        type: String,
        default: ''
      },
      ReportList: {
        type: Array,
        default: function () {
          return []
        }
      },
    },
    computed: {},
    watch: {
      TableData (c, o) {
        this.privateResult = []
        this.publicResult = []
        c.forEach(e => {
          if (e.privateType === '个人') this.privateResult.push(e)
          else this.publicResult.push(e)
        })
        this.$emit('ValLength', c.length);
      },
      data (c, o) {
        this.privateTypeList = this.data[0] && this.data[0].privateType
        this.$nextTick(() => {
          let result = this.privateTypeList === '个人' ? this.privateResult : this.publicResult
          this.data.forEach(row => {
            for (let item of result) {
              if (item.id === row.id) {
                this.$refs.multipleTable.toggleRowSelection(row, true)
                break
              }
            }
          })
        })
      }
    },
    created() {
    },
    mounted() {
    },
    methods: {
      _operation(row, operation,index) {
        let payload = Object.assign(row, {
          operation,
          index
        })
        this.$emit('_operation', payload)
      },
      handleSelectAll(val){
        if(val.length!==0){
          let obj = {}
          let arr = this.privateType === '个人' ? this.privateResult : this.publicResult
          for (let i in arr) {
            obj[arr[i].id] = arr[i]
          }
          if (val.length) {
            for (let e of val) {
              if (!obj[e.id]) {
                arr.push(e)
              }
            }
          } else {
            for (let e of this.data) {
              if (obj[e.id]) {
                delete obj[e.id]
              }
            }
            arr = []
            for (let e of obj) {
              arr.push(e)
            }
            if (this.privateType === '个人') this.privateResult = arr
            else this.publicResult = arr
          }
          this.$emit('ValLength', this.privateResult.length + this.publicResult.length);
        } else {
          this.privateResult = []
          this.publicResult = []
          this.$emit('ValLength', this.privateResult.length + this.publicResult.length);
        }
      },
      handleSelectionChange(val, row){
        let i = -1
        for (let e of val) {
          if (e.id === row.id) {
            i = 0
            break
          }
        }
        if (this.privateType === '个人') {
          if (i === -1) {
            for (let j in this.privateResult) {
              if (this.privateResult[j].id === row.id) {
                i = j
                break
              }
            }
            this.privateResult.splice(i, 1)
          } else {
            this.privateResult.push(row)
          }
        } else {
          if (i === -1) {
            for (let j in this.publicResult) {
              if (this.publicResult[j].id === row.id) {
                i = j
                break
              }
            }
            this.publicResult.splice(i, 1)
          } else {
            this.publicResult.push(row)
          }
        }
        this.$emit('ValLength', this.privateResult.length + this.publicResult.length);
      },
      getList(){
        this.$emit('tableVal', [...this.publicResult, ...this.privateResult])
      }
    },
    data() {
      return {
        result: [],
        privateResult: [],
        publicResult: [],
        height: 330,
        show: true,
        applyToMeOperation: [],
        multipleSelection:[],
        privateTypeList:[],
        select_orderId:[],
        getRowKeys(row) {
          return row.id;
        },
      }
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable.styl'

</style>



// WEBPACK FOOTER //
// table.vue?163b7ee0